window.app = window.app || {};

window.app.banner = {
  elements: document.querySelectorAll('.mt-banner-carousel'),
  videos: document.querySelectorAll('.mt-banner__video'),
  buttons: document.querySelectorAll('.mt-banner .mt-btn'),
  breakpoint: 'mobile',
  sliders: [],

  init: function () {
    const _this = this;

    // Videos
    _this.videos.forEach(video => {
      video.addEventListener('loadeddata', () => video.classList.add('is-visible'));
    });

    // Sliders
    _this.elements.forEach(element => {
      const swiperWrapper = element.querySelector('.swiper');
      const slider = new Swiper(swiperWrapper, {
        autoHeight: element.classList.contains('mt-banner-carousel--static-text'),
        slidesPerView: 1,
        spaceBetween: 0,
        direction: 'horizontal',
        draggable: true,
        allowTouchMove: true,
        loop: true,
        effect: 'fade',
        speed: 300,
        autoplay: {
          delay: swiperWrapper.dataset.delay || 7000,
          disableOnInteraction: false
        },
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          clickable: true
        }
      });
      slider.on('slideChangeTransitionStart', s => {
        const allSlidesVideos = element.querySelectorAll('.swiper-slide .mt-banner__video');
        allSlidesVideos.forEach(video => !video.paused && video.pause());

        const nextSlide = s.slides[s.realIndex];
        const nextVideos = nextSlide.querySelectorAll('.mt-banner__video');
        nextVideos.forEach(video => video.load());
      });
      slider.on('slideChangeTransitionEnd', s => {
        const allSlidesVideos = element.querySelectorAll('.swiper-slide:not(.swiper-slide-active) .mt-banner__video');
        const currentSlideVideos = element.querySelectorAll('.swiper-slide-active .mt-banner__video');

        allSlidesVideos.forEach(video => {
          video.currentTime = 0;
          !video.paused && video.pause();
        });
        currentSlideVideos.forEach(video => {
          video.currentTime = 0;
          video.play();
        });
      });
      _this.sliders.push(slider);
    });

    // Additional events
    _this.buttons.forEach(btn => {
      const slideHeader = btn.closest('.mt-banner__content')?.querySelector('.mt-banner__header');
      if (!slideHeader) return;
      btn.addEventListener('click', () => app.dl.ctaClick(slideHeader.innerText, { location: 'Hero' }));
    });
  },
};
window.app.banner.init();